import styled from '@emotion/styled';

export const FullSizeContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  marginBottom: 'center',
});
